import React from 'react';
import useToggle from '../../Hooks/useToggle';
import BackToTop from '../BackToTop';
import FooterHomeOne from '../HomeOne/FooterHomeOne';
import Drawer from '../Mobile/Drawer';
import HeaderAbout from './HeaderAbout';
import GalleryAbout from './GalleryAbout';
import HeroAbout from './HeroAbout';
// import ServicesAbout from './ServicesAbout'; // template values grid, replaced by the gallery
// import TeamAbout from './TeamAbout'; // Team hidden for now

function AboutUs() {
    const [drawer, drawerAction] = useToggle(false);

    return (
        <>
            <Drawer drawer={drawer} action={drawerAction.toggle} />
            <HeaderAbout drawer={drawer} action={drawerAction.toggle} />
            <HeroAbout />
            <GalleryAbout />
            {/* <TeamAbout /> Team hidden for now */}
            <FooterHomeOne />
            <BackToTop />
        </>
    );
}

export default AboutUs;
